// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const SUPABASE_URL = "https://crprviwjjqmvmwdbnvnm.supabase.co";
//const SUPABASE_URL = "https://kwwluqvceizjfrfdscda.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  //"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt3d2x1cXZjZWl6amZyZmRzY2RhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDcwNjU1MDksImV4cCI6MjA2MjY0MTUwOX0.DHpRVxaJYoM4AU-ANm5UnTQ3MSakmvOa4UfrBgJ-rLs";
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNycHJ2aXdqanFtdm13ZGJudm5tIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDUxNzAzOTksImV4cCI6MjA2MDc0NjM5OX0.gF1b6mHuu_0UQbNFUO8fnGUkGWSjhLot2GPOTOtrMtY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY
);
